<template>
  <modal
  name="set-title-modal"
  height="auto"
  :pivot-y="0.3"
  :adaptive="true"
  :width="428"
  @before-open="beforeOpen">
    <div class="SetTitle__container">
      <div class="SetTitle__title">
        Add title to conference
      </div>
      <div class="SetTitle__form">
        <div class="Grid-row">
          <div class="form-label uppercase">
            title
          </div>
          <input
          v-focus
          type="text"
          name="title"
          placeholder="Enter title here"
          v-model="title"
          class="field"
          :class="{'is-danger': errors.has('title')}"
          v-validate="'required'"
          data-vv-delay="500"
          data-vv-as="TITLE"
          data-vv-name="title"
          required
          @keyup.enter.prevent="submit">
        </div>
        <div class="Grid-row">
          <div class="form-actions pull-right">
            <a @click="cancel"
               class="cancel-btn">cancel</a>
            <a @click="submit"
               class="submit-btn">save</a>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'SetTitle',
    data() {
      return {
        title: null
      };
    },
    methods: {
      submit(e) {
        e.preventDefault();
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$store.dispatch('setConferenceTitle', this.title);
            this.$modal.hide('set-title-modal');
          }
        });
      },
      cancel() {
        this.$modal.hide('set-title-modal');
      },
      beforeOpen(event) {
        this.title = event.params.title;
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// set-title.modal.vue?01d90a7a